import cx from 'classnames';

export default props => (
  <div
    className={cx('loader-wrapper text-center', {
      inline: props.inline,
      [`float--${props.float}`]: props.inline,
    })}
  >
    <span className="loader text-center inline-block" />
    <style jsx>
      {`
        .loader-wrapper {
          padding: ${props.noPadding ? '0' : '20px'};
        }

        .loader-wrapper.inline {
          padding: 0;
        }

        .loader {
          border: 2px solid #f8f8f8;
          width: ${props.size ? props.size : '25px'};
          height: ${props.size ? props.size : '25px'};
          border-radius: 50%;
          border-top: 2px solid #16d916;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @-webkit-keyframes spin {
          0% {
            -webkit-transform: rotate(0deg);
          }
          100% {
            -webkit-transform: rotate(360deg);
          }
        }
      `}
    </style>
  </div>
);



// WEBPACK FOOTER //
// ./components/ui/Loader.tsx